<template>
    <div>
       <Navbar :tab-index="tab_selected" />

    <div class="home" id="Home" v-intersect="handleIntersect">
     
     <v-container>
        <v-row align='center'>
          <v-col  class="mb-6" cols="12" sm="6" align="center"> 
            <v-img class="rounded-lg" :src="require('../assets/nidianatalbw.webp')" contain :width="$vuetify.breakpoint.xs 
                ? '300px' 
                : ($vuetify.breakpoint.sm
                    ? '300px' 
                    : ($vuetify.breakpoint.md
                        ? '300px'
                        : ($vuetify.breakpoint.lg
                            ? '400px' 
                            : '400px'
                        )
                    )
                )" ></v-img>
          </v-col>
          <v-col class="mb-6" cols="12" sm="6" align='left' > 
            <h1>Olá, eu sou a Nídia Natal.</h1>
            <p class="body-1">Sou uma rapariga cheia de sonhos natural do Funchal. Um dia optei por lutar por eles e decidi escrever um livro. Poderia ter o sonho de uma viagem a um local paradisíaco, contudo quis dar voz aos meus pensamentos e assim o fiz. Hoje vivo sabendo que os sonhos são reais.</p>
            <div>&nbsp;</div>
            <div>&nbsp;</div>
            
              <v-btn 
                @click="sendMail()"
                type="submit"
                elevation="2"
                dark
                x-large>
              <v-icon left>
                mdi-shopping
              </v-icon>
              Comprar agora! (13€)
              </v-btn>

          </v-col>

        </v-row>

      </v-container>

  </div>
  <v-spacer></v-spacer>
  <v-divider></v-divider>
  <v-spacer></v-spacer>
  <v-spacer></v-spacer>
  <div class="dela" id="Dela" v-intersect="handleIntersect">
    <v-container>
        <v-row align='center'>
          
          <v-col class="mb-6" cols="12" sm="6" align='left' > 
            <h1>D'ela</h1>
            <div>&nbsp;</div>
            <p class="body-1">
              Inês é uma jovem adulta tal como todos os outros. Não tem super poderes nem faz truques de magia. D'ela é um livro que o leva pela vida desta jovem, num misto de emoções que o farão parar e viver.
              Entre escolhas e mudanças, Inês sofre e ama.
            </p>
            <p class="body-1">
              
               Muitas vezes pensamos na nossa vida e sentimos que chegamos a um impasse, não sabemos bem que rumo seguir e deixamos fluir. A lição mais importante é viver.
            </p>
            <div>&nbsp;</div>
            <div>&nbsp;</div>
            <!-- <form method="post" action="mailto:nidia.natal@hotmail.com?subject=Comprar livro D'ela&body=Olá gostaria de adquirir o livro D'ela.  %0D%0A%0D%0AQuantidade: %0D%0ADedicatória: (Sim/Não) %0D%0AMorada de envio:%0D%0AModo de pagamento: (MbWay/Transferência multibanco)%0D%0AOs portes têm um custo de 2 euros."> -->
              <v-btn 
                @click="sendMail()"
                type="submit"
                dark
                elevation="2"
                x-large>
              <v-icon left>
                mdi-shopping
              </v-icon >
              Comprar agora! (13€)
              </v-btn>
            <!-- </form> -->
            <div>&nbsp;</div>
            <p class="body-1">
              
              Também disponível nas livrarias Astrolábio Edições, Bertrand e Fnac.
            
            </p>
          </v-col>
          <v-col  class="mb-6" cols="12" sm="6" align="center"> 
            <v-img class="rounded-lg" :src="require('../assets/delabook.webp')" contain :width="$vuetify.breakpoint.xs 
                ? '400px' 
                : ($vuetify.breakpoint.sm
                    ? '400px' 
                    : ($vuetify.breakpoint.md
                        ? '400px'
                        : ($vuetify.breakpoint.lg
                            ? '400px' 
                            : '400px'
                        )
                    )
                )" ></v-img>
          </v-col>

        </v-row>

      </v-container>
    
  </div>
  <v-spacer></v-spacer>
  <v-divider></v-divider>
  <v-spacer></v-spacer>
  <v-spacer></v-spacer>
 
  <div class="niarte" id="Niarte" v-intersect="handleIntersect">
     
     <v-container>
        <v-row align='center'>
          <v-col  class="mb-6" cols="12" sm="6" align="center"> 
            <v-img class="rounded-lg" :src="require('../assets/niarte.webp')" contain :width="$vuetify.breakpoint.xs 
                ? '300px' 
                : ($vuetify.breakpoint.sm
                    ? '300px' 
                    : ($vuetify.breakpoint.md
                        ? '300px'
                        : ($vuetify.breakpoint.lg
                            ? '400px' 
                            : '400px'
                        )
                    )
                )" ></v-img>
          </v-col>
          <v-col class="mb-6" cols="12" sm="6" align='left' > 
            <h1>Niarte, a arte da Ni para si!</h1>
            <p class="body-1">Loja de venda de produtos feitos em jesmonite, pó cerâmico, pedra hidrofuga e de madeira feitos a partir de uma máquina de corte a laser.</p>
            <div>&nbsp;</div>
            <div>&nbsp;</div>
            
              <v-btn 
              href="https://niarte-funchal.com"
                type="submit"
                elevation="2"
                dark
                x-large>
              <v-icon left>
                mdi-shopping
              </v-icon>
              Visitar loja!
              </v-btn>

          </v-col>

        </v-row>

      </v-container>

  </div>

    </div>
  
</template>

<script>
import Navbar from './Navbar.vue'

export default {
  components: { Navbar},
  data: () => ({
    tab_selected: "Home",
  }),
  
  methods: {
    sendMail() {
      window.open("mailto:nidia.natal@hotmail.com?subject=Comprar livro D'ela&body=Olá gostaria de adquirir o livro D'ela.  %0D%0A%0D%0AQuantidade: %0D%0ADedicatória: (Sim/Não) %0D%0AMorada de envio:%0D%0AModo de pagamento: (MbWay/Transferência multibanco)%0D%0AOs portes têm um custo de 2 euros.", '_blank');
    },
    handleIntersect(isIntersecting, entries) {
        let intersecting_element = entries[0];
        
      if (intersecting_element?.isIntersecting) {
        let id = intersecting_element.target.id;
        console.log(id)
        this.tab_selected = id
      }
    }
  }
}
</script>


<style scoped>
.home {
  margin-top: 100px;
   margin-bottom: 100px;
  /* height: 65vh; */
} 
.dela {
  margin-top: 100px;
  margin-bottom: 100px;
  /* height: 60vh; */
}
.niarte {
  margin-top: 100px;
  margin-bottom: 100px;
  /* height: 60vh; */
}
</style>

